import {Breadcrumb} from '@/__generated__/__types__';
import {getProductUrl, type Product} from '../model/product';
import {convertDataToBreadCrumbs} from '../../categories/models/bread-crumbs';
import {BreadcrumbInterface} from '@/_application/core/components/ui/breadcrumbs/breadcrumbs';

export const getBreadCrumsByProduct = (product: Product) => {
    if (!product?.id || !product?.breadcrumbs?.length) {
        return null;
    }

    const productBreadCrumbs = product.breadcrumbs as Breadcrumb[];

    const categoryBreadcrumbs = convertDataToBreadCrumbs([...productBreadCrumbs]);

    const breadcrumbs = [
        ...categoryBreadcrumbs,
        {id: product.id.toString(), url: `${getProductUrl(product, false)}`, title: product.name ?? ''},
    ];

    return {
        breadcrumbs: breadcrumbs,
        breadcrumbsSeoSchema: getBreadCrumsSeoSchema(breadcrumbs),
    };
};

export const getBreadCrumsSeoSchema = (breadCrumbs: BreadcrumbInterface[]) => {
    const baseUrl = process.env.NEXT_PUBLIC_BASE_SHOP_URL_ENDPOINT;

    const listBread = breadCrumbs?.map((bread, index) => ({
        '@type': 'ListItem',
        name: bread.title,
        position: index + 2,
        item: `${baseUrl}${bread.url}`,
    }));

    const seoBreadCrumbItemList = [
        {
            '@type': 'ListItem',
            name: 'Trang chủ',
            position: 1,
            item: baseUrl,
        },
        ...listBread,
    ];

    const schema = {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: seoBreadCrumbItemList,
    };

    return schema;
};

export const getBreadCrumsByCategory = (
    categoryName: string,
    categoryUrl: string,
    breadCrumbItems: Breadcrumb[],
) => {
    const formatUrl = `/${categoryUrl}`;

    const breadcrumbs = convertDataToBreadCrumbs([...breadCrumbItems]);
    const newBreadcrumbs = [...breadcrumbs, {id: categoryName, url: formatUrl, title: categoryName}];

    return {
        categoryBreadCrumbs: newBreadcrumbs,
        categoryBreadCrumbsSeoSchema: getBreadCrumsSeoSchema(newBreadcrumbs),
    };
};
